import React from "react";
import {NavLink} from "react-router-dom";
import PageActions from "../../../base/PageActions";
import ContentBox from "../../../../components/content-box/ContentBox";
import KofiButton from "../../../../components/kofi-button/KofiButton";
import _image_service from "../../../../services/ImageService";
import '../../../styles/Common.scss';
import './DownloadsPage.scss';

interface DownloadsPageProps {
}

const DownloadsPage = (props: DownloadsPageProps) => {

    const page: PageActions = new PageActions({
        title: `Downloads - Chase the Fox`,
        description: "Anything that Chase has created for others to download can be found here!",
        keywords: ["download", "downloadable", "creations"],
        imgSrc: `chase/assets/chase_full.png`,
        url: `downloads`
    });

    return page.generateMetaContent(
        <ContentBox className="downloads-content" header="Downloads">
            <img className="downloads-header-image"
                 src={_image_service.getCdnImageSrc(`chase/assets/chase_full.png`)}
                 alt="Chase"
                 title="Check out these free downloads!"/>
            <p>
                Anything I'm offering up for folks to download can be found here! Clicking on a link will take you to a
                new page that will describe the item and allow you to download a copy. If you use anything here,
                please consider crediting me.
            </p>
            <p className="center">
                If you'd like to support me and my future creations, consider buying me a Ko-fi!
            </p>
            <p className="center">
                <KofiButton className="downloads-ko-fi-button"/>
            </p>
            <ul className="download-list center separated-list-elements no-bullets">
                <li>
                    <NavLink to="super-fox">Super Fox 2D Vtuber</NavLink>: A vtuber model based on the Super Fox
                    from Super Animal Royale
                </li>
            </ul>
            <p className="center">
                If you have any questions, feel free
                to <NavLink to="/contact" target="_blank" rel="noopener noreferrer">contact me</NavLink>!
            </p>
        </ContentBox>
    );
}

export default DownloadsPage;